module.exports = __webpack_public_path__ + "img/h5-05-2.0316447e.png";